// Hand-picked combo "feasts" for Rivaaz. Each step picks ONE menu item from a
// category; wizard adds everything to cart together at menu prices.
// `preferred_variant` auto-selects that variant if the chosen item has it.

export const FEASTS = [
  {
    slug: "date-night",
    name: "Date Night for Two",
    tagline: "A cozy pairing — starter, curry, naan, and dessert.",
    priceHint: "≈ $58",
    serves: "2",
    accent: "#C9853E",
    hero: "https://images.unsplash.com/photo-1601050690597-df0568f70950?w=1400&q=80",
    steps: [
      {
        title: "Pick a shared starter",
        category_slug: "appetizers",
        hint: "Crispy, shareable — chicken 65 or veg pakora always hit.",
      },
      {
        title: "Choose a curry",
        category_slug: "curry-specialties",
        hint: "Butter chicken for creamy, lamb for bold.",
      },
      {
        title: "Add tandoori bread",
        category_slug: "tandoori-breads",
        hint: "Garlic naan is our most-ordered.",
      },
      {
        title: "Finish with dessert",
        category_slug: "desserts",
        hint: "Gulab jamun, always.",
      },
    ],
  },
  {
    slug: "family-feast",
    name: "Family Feast",
    tagline: "Feeds 4–5. A large pizza, curry, rice/biryani, bread and dessert.",
    priceHint: "≈ $120",
    serves: "4–5",
    accent: "#A6692D",
    hero: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=1400&q=80",
    steps: [
      {
        title: "Pick a large pizza",
        category_slug: "pizzas",
        hint: "Large feeds 3–4.",
        preferred_variant: "Large",
      },
      {
        title: "Choose a curry",
        category_slug: "curry-specialties",
        hint: "Butter chicken for creamy, lamb for bold.",
      },
      {
        title: "Appetizer platter",
        category_slug: "appetizers",
        hint: "Enough to pass around.",
      },
      {
        title: "Rice or biryani",
        category_slug: "rice-specialties",
        hint: "A biryani makes the table feel full.",
      },
      {
        title: "Tandoori bread",
        category_slug: "tandoori-breads",
        hint: "Garlic naan, cheese naan, or a paratha for the table.",
      },
      {
        title: "Dessert to share",
        category_slug: "desserts",
        hint: "Trust us.",
      },
    ],
  },
  {
    slug: "office-lunch",
    name: "Office Lunch for 6",
    tagline: "Fuel the team. Two large pizzas, sides and cold drinks.",
    priceHint: "≈ $95",
    serves: "6",
    accent: "#0E0E1A",
    hero: "https://images.unsplash.com/photo-1604382354936-07c5d9983bd3?w=1400&q=80",
    steps: [
      {
        title: "First pizza",
        category_slug: "pizzas",
        hint: "Go with a crowd-pleaser — chicken tikka pizza.",
        preferred_variant: "Large",
      },
      {
        title: "Second pizza",
        category_slug: "pizzas",
        hint: "Keep it vegetarian so everyone's covered.",
        preferred_variant: "Large",
      },
      {
        title: "Appetizers",
        category_slug: "appetizers",
        hint: "Samosas always land.",
      },
      {
        title: "Drinks",
        category_slug: "beverages",
        hint: "Mango lassi or a cold bottle.",
      },
    ],
  },
];

export const findFeast = (slug) => FEASTS.find((f) => f.slug === slug);
